import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TradeTransaction {
  txId: string;
  txDt: string;
  txCode: number;
  pCode: string;
  pName: string;
  regNo: string;
  itemName: string;
  qty: number;
  unitPrice: number;
  supplyAmt: number;
  vatAmt: number;
  svcAmt: number;
  cardCompany: string;
  cardNumber: string;
  txJournalType: number;
  reliability: number;
  precaution: number;
}

interface TradeTransactionState {
  transactions: TradeTransaction[];
  loading: boolean;
  error: string | null;
}

const initialState: TradeTransactionState = {
  transactions: [],
  loading: false,
  error: null,
};

const tradeTransactionSlice = createSlice({
  name: 'tradeTransaction',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTransactions: (state, action: PayloadAction<TradeTransaction[]>) => {
      state.transactions = action.payload;
      state.loading = false;
      state.error = null;
    },
    clearTransactions: (state) => {
      state.transactions = [];
      state.loading = false;
      state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setLoading, setTransactions, clearTransactions, setError } = tradeTransactionSlice.actions;
export default tradeTransactionSlice.reducer;